module.exports = __webpack_public_path__ + "img/E1.1e862348.svg";